<template>
  <div>
    <!-- <v-dialog
      v-model="redirect"
      hide-overlay
      transition="dialog-bottom-transition"
      fullscreen
      :src="src"
    >  -->
    <!-- <v-card > -->
    <!-- <v-toolbar dark class="gradient-bg2" flat >
          <v-toolbar-items>
            <v-toolbar-title class="white--text mt-3">Payment</v-toolbar-title>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="closeRequest()">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>  -->

    <!-- <iframe
          v-if="show"
          :src="src"
          frameborder="0"
          width="100%"
          height="600"
          class="mt-2"
        ></iframe> -->
    <!-- </v-card> -->
    <!-- </v-dialog> -->
    <!-- <postpayment :txnstatus="txnstatus" /> -->
  </div>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  data: () => ({
    packValue: "",
    amounttosent: "",
    checkfp: false,
    min: 1,
    max: 999999999999999999,
    randomnumber: "",
    show: true,
    // src: ""
    src: "",
    redirect: false,
    paymentMode: "",
    getpath: "",
    txnstatus: "",
  }),

  methods: {
    closeRequest() {
      this.redirect = false;
      this.amounttosent = "";
      this.packValue = "";
      this.src = "";
      if (
        this.$store.getters.get_getCustDetails.is_purchase == 0 ||
        this.$store.getters.get_getCustDetails.is_purchase == 1
      ) {
        this.$router.push("/Dashboard");
      } else {
        this.$router.push("/corporatefundrequest");
      }
    },

    async getCallfororderId(value, packValue, paymentMode, data, packid) {
      this.amounttosent = parseFloat(value).toFixed(2);
      this.packValue = packValue;
      this.paymentMode = paymentMode;
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EGHL",
          corp_id: this.$store.getters.get_corpid,
          user_id: this.$store.getters.get_userid,
          amount: this.amounttosent,
          card_type: data,
          quantity: this.packValue,
          packid: packid,
          status: "4",
        },
      };

      var responseData = await apiCall(inputData);
      if (responseData.data.data != null || responseData.data.data != "") {
        this.randomnumber = responseData.data.data[0].order_no;
        if (data == 1 || data == 2) {
          this.checkfp = true;
        }
        this.cardandfpxapi(
          paymentMode,
          this.randomnumber,
          this.amounttosent,
          this.checkfp
        );

        this.getURL();
      }
    },
    async cardandfpxapi(paymentMode, randomnumber, amounttosent, checkfp) {
      var inputData = {
        method_name: "CFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CREATE",
          corp_id: this.$store.getters.get_corpid,
          payment_mode: paymentMode == "CC" ? 3 : 4,
          order_no: randomnumber,
          request_type: this.getrequesttype(checkfp, paymentMode),
          payment_detail: {
            bank_info: null,
            pay_id: null,
            date_of_txn: null,
          },
          initiated_by: this.$store.getters.get_userid,
          amount: amounttosent,
          comments: null,
          fund_type: 1,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        // this.$store.commit("snackbar/showMessage", {
        //   content:  responseData.data.status_msg,
        //   color: "green",
        // });
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }
    },
    getrequesttype(data, paymentMode) {
      if (data == true) {
        return 1;
      } else if (data == false) {
        if (paymentMode == "CC") {
          return 8;
        } else {
          return 6;
        }
      }
    },

    generateNumber() {
      return Math.floor(Math.random() * (this.max - this.min + 1) + this.min);
    },

    //  this.$store.getters.getApiCredentials.baseUrl.includes("staging") == true
    getURL() {
      if (
        this.$store.getters.getApiCredentials.baseUrl.includes("dev") == true ||
        this.$store.getters.getApiCredentials.baseUrl.includes("staging") ==
          true
      ) {
        this.show = true;
        var Password = "sit12345";
        var serviceId = "SIT";
        var orderNo = this.randomnumber;

        var Currency = "MYR";
        var pageTimeout = 750;

        var merchantReturnURL =
          this.$store.getters.getApiCredentials.baseUrl + "/EGHLPostPayment";
        //localhost:8080/EGHLCallback
        var merchantCallbackURL =
          this.$store.getters.getApiCredentials.baseUrl + "/EGHLCallback";
        //var merchantCallbackURL = "localhost:8080/EGHLCallback";

        var userMobNo = "1500000237";
        var userName = this.$store.getters.get_getCustDetails.user_name;
        var custIP = "106.77.51.143";
        // var AES = require("crypto-js/aes");
        var SHA256 = require("crypto-js/sha256");
        var HashValue =
          Password +
          serviceId +
          orderNo +
          merchantReturnURL +
          merchantCallbackURL +
          this.amounttosent +
          Currency +
          custIP +
          pageTimeout;
        var hashDigest = SHA256(HashValue);
        let param = {
          TransactionType: "SALE",
          PymtMethod: "ANY",
          IssuingBank:"HostSim",
          ServiceID: serviceId,
          PaymentID: orderNo,
          OrderNumber: orderNo,
          PaymentDesc: "Glyd-INSTAPAY",
          MerchantName: "GLYD",
          MerchantReturnURL: merchantReturnURL,
          MerchantCallBackURL: merchantCallbackURL,
          Amount: this.amounttosent,
          CurrencyCode: Currency,
          CustIP: custIP,
          CustName: userName,
          CustEmail: "eghl@instapaytech.com",
          CustPhone: userMobNo,
          HashValue: hashDigest.toString(),
          LanguageCode: "EN",
          PageTimeout: pageTimeout,
        };
        let qData = require("querystring").stringify(param);
        this.src = `https://pay.e-ghl.com/IPGSG/Payment.aspx?${qData}`;
        //eghl url we are creating here
        // window.open(this.src,"_self");
        var popupnew = require("window-popup").windowPopup;
        popupnew(500, 500, this.src);
      } else if (
        this.$store.getters.getApiCredentials.baseUrl.includes("corporate") ==
        true
      ) {
        this.show = true;
        var PasswordCoporate = "b4R1z6H9RG6MMN5427NJi2fjNRE6q4gv";
        var serviceIdCorporate = "IS2";
        // var PasswordCoporate = "sit12345";
        // var serviceIdCorporate = "SIT";
        var orderNoCorporate = this.randomnumber;

        var CurrencyCorporate = "MYR";
        var pageTimeoutCoporate = 750;
        //
        var merchantReturnURLCorporate = //"http://localhost:8080/#/postpayment";
          this.$store.getters.getApiCredentials.baseUrl + "/EGHLPostPayment";
        // console.log("merchantReturnURLCorporate", merchantReturnURLCorporate);
        // "http://localhost:8080/#/postpayment";
        //localhost:8080/EGHLCallback
        var merchantCallbackURLCorporate =
          this.$store.getters.getApiCredentials.baseUrl + "/EGHLCallback";
        // console.log(
        //   "merchantCallbackURLCorporate",
        //   merchantCallbackURLCorporate
        // );
        //var merchantCallbackURL = "localhost:8080/EGHLCallback";

        var userMobNoCorporate = "1500000237";
        var userNameCorporate =
          this.$store.getters.get_getCustDetails.user_name;
        var custIPCorporate = "106.77.51.143";
        // var AES = require("crypto-js/aes");
        var SHA258 = require("crypto-js/sha256");
        var HashValueCorporate =
          PasswordCoporate +
          serviceIdCorporate +
          orderNoCorporate +
          merchantReturnURLCorporate +
          merchantCallbackURLCorporate +
          this.amounttosent +
          CurrencyCorporate +
          custIPCorporate +
          pageTimeoutCoporate;
        var hashDigestCorporate = SHA258(HashValueCorporate);
        let param = {
          TransactionType: "SALE",
          PymtMethod: this.paymentMode,
          ServiceID: serviceIdCorporate,
          PaymentID: orderNoCorporate,
          OrderNumber: orderNoCorporate,
          PaymentDesc: "Glyd-INSTAPAY",
          MerchantName: "INSTAPAY",
          MerchantReturnURL: merchantReturnURLCorporate,
          MerchantCallBackURL: merchantCallbackURLCorporate,
          Amount: this.amounttosent,
          CurrencyCode: CurrencyCorporate,
          CustIP: custIPCorporate,
          CustName: userNameCorporate,
          CustEmail: "eghl@instapaytech.com",
          CustPhone: userMobNoCorporate,
          HashValue: hashDigestCorporate.toString(),
          LanguageCode: "EN",
          PageTimeout: pageTimeoutCoporate,
        };
        let qData = require("querystring").stringify(param);
        // this.src = `https://securepay.e-ghl.com/IPG/Payment.aspx?${qData}`;  production url
        this.src = `https://securepay.e-ghl.com/IPG/Payment.aspx?${qData}`;
        // eghl url we are creating here
        // console.log("this.src",this.src);
        // window.open(this.src,"_parent");
        var popup = require("window-popup").windowPopup;
        popup(500, 500, this.src);
      }
    },
    getIPAddress() {
      var interfaces = require("os").networkInterfaces();
      for (var devName in interfaces) {
        var iface = interfaces[devName];

        for (var i = 0; i < iface.length; i++) {
          var alias = iface[i];
          if (
            alias.family === "IPv4" &&
            alias.address !== "127.0.0.1" &&
            !alias.internal
          )
            return alias.address;
        }
      }
      return "0.0.0.0";
    },
  },
};
</script>

<style></style>
